import accounting from './accounting';
import ai from './ai';
import banking from './banking';
import crm from './crm';
import finance from './finance';
import help from './help';
import home from './home';
import hr from './hr';
import inventory from './inventory';
import investment from './investment';
import loans from './loans';
import payables from './payables';
import portals from './portals';
import practiceManagement from './practice-management';
import profile from './profile';
import projects from './projects';
import receivables from './receivables';
import reports from './reports';
import settings from './settings';
import shared from './shared';
import system from './system';
import taxCompliance from './tax-compliance';

let messages = Object.assign({}, accounting, ai, banking, crm, finance, help, home, hr, inventory, investment, loans, payables, portals, practiceManagement, profile, projects, receivables, reports, settings, shared, system, taxCompliance);

export default messages;
